import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsBottomSheetComponent } from "./ds-bottom-sheet.component";
import { DsButtonModule } from "../ds-button/ds-button.module";
import { DsTooltipDirective } from "../directive/ds-tooltip.directive";

@NgModule({
  declarations: [DsBottomSheetComponent],
  imports: [CommonModule, DsButtonModule, DsTooltipDirective],
  exports: [DsBottomSheetComponent],
})
export class DsBottomSheetModule {}
